import { render, staticRenderFns } from "./LayContentAll.vue?vue&type=template&id=28585cb0&"
import script from "./LayContentAll.vue?vue&type=script&lang=js&"
export * from "./LayContentAll.vue?vue&type=script&lang=js&"
import style0 from "./LayContentAll.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports